import { BackendApiResponse, DateTimeString } from '.';

export enum OperatorPermission {
  GetTasks = 'GetTasks',
  Family = 'Family',
  DelayTask = 'DelayTask',
  RequestStartAssignation = 'RequestStartAssignation',
}

export enum OperatorStatus {
  WorkingOnTasks = 'WorkingOnTasks',
  Break = 'Break',
  Training = 'Training',
  Meeting = 'Meeting',
  AdministrativeWork = 'AdministrativeWork',
  WorkingInAnotherDep = 'WorkingInAnotherDep',
  Offline = 'Offline',
}

export interface FamilyFunctionalStatus {
  familyFunctionalIsAvailable: boolean;
}
export type FamilyFunctionalStatusResponse = FamilyFunctionalStatus;

export interface OperatorStatusData {
  type: OperatorStatus;
  startsAt: DateTimeString;
}
export type OperatorStatusDataResponse = BackendApiResponse<OperatorStatusData>;

export interface CurrentOperator {
  code: number;
}
